
import React from 'react';
import CandidatePipeline from "@/components/candidates/CandidatePipeline";
import { AppErrorBoundary } from "@/components/error-handling/AppErrorBoundary";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PipelineDashboard } from '@/components/candidates/dashboard/PipelineDashboard';
import { useCandidates } from '@/hooks/useCandidates';
import { LoadingState } from '@/components/error-handling/LoadingState';
import { BarChart3, UsersRound } from 'lucide-react';
import { StagePerformance } from '@/components/candidates/analytics/StagePerformance';

const PipelinePage = () => {
  const [activeView, setActiveView] = React.useState<'pipeline' | 'dashboard'>('pipeline');
  const { data: candidates = [], isLoading } = useCandidates();

  return (
    <div className="w-full p-4 md:p-6 space-y-6">
      <header>
        <h1 className="text-3xl font-bold tracking-tight">Recruitment Pipeline</h1>
        <p className="text-muted-foreground">
          Manage candidates and monitor recruitment metrics.
        </p>
      </header>

      <Tabs value={activeView} onValueChange={(value) => setActiveView(value as 'pipeline' | 'dashboard')}>
        <TabsList>
          <TabsTrigger value="pipeline" className="flex items-center gap-2">
            <UsersRound className="h-4 w-4" />
            Pipeline View
          </TabsTrigger>
          <TabsTrigger value="dashboard" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Analytics Dashboard
          </TabsTrigger>
        </TabsList>

        <TabsContent value="pipeline" className="mt-4">
          <AppErrorBoundary>
            <CandidatePipeline />
          </AppErrorBoundary>
        </TabsContent>

        <TabsContent value="dashboard" className="mt-4">
          <AppErrorBoundary>
            {isLoading ? (
              <LoadingState message="Loading analytics data..." />
            ) : (
              <div className="space-y-8">
                <PipelineDashboard candidates={candidates} isLoading={isLoading} />
                <StagePerformance candidates={candidates} />
              </div>
            )}
          </AppErrorBoundary>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PipelinePage;
